import { Formik } from "formik";
import React, { useState } from "react";
import { Icon } from "react-icons-kit";
import { eye } from "react-icons-kit/feather/eye";
import { eyeOff } from "react-icons-kit/feather/eyeOff";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import BlockUI from "../../base/components/BlockUI";
import { LocalStorageService } from "../../base/services/local-storage.service";
import { createUser } from "./authSlice";
import Popup from "./components/modal/Popup";
import "./style.scss";
import { ReactComponent as RegisterPhoto } from "../../assets/icons/registerPhoto.svg";
import { ReactComponent as Wave } from "../../assets/icons/wave.svg";
import zIndex from "@material-ui/core/styles/zIndex";

const initialValues = {
   fullName: "",
   email: "",
   password: "",
   confirmPassword: ""
};

function Registration() {
   const navigate = useNavigate();
   // const dispatch = useDispatch();

   // const [type, setType] = useState("password");
   // const [icon, setIcon] = useState(eyeOff);

   // const handleToggle = () => {
   //    if (type === "password") {
   //       setIcon(eye);
   //       setType("text");
   //    } else {
   //       setIcon(eyeOff);
   //       setType("password");
   //    }
   // };

   // const [show, setShow] = useState(false);
   // const handleShow = () => setShow(true);

   // const RegistrationSchema = Yup.object().shape({
   //    fullName: Yup.string()
   //       .min(3, "Minimum 3 symbols")
   //       .max(50, "Maximum 50 symbols")
   //       .required("Required"),
   //    email: Yup.string()
   //       .email("Invalid email")
   //       .required("Required"),
   //    password: Yup.string()
   //       .min(3, "Minimum 3 symbols")
   //       .max(50, "Maximum 50 symbols")
   //       .required("Required"),
   //    confirmPassword: Yup.string()
   //       .label("confirm password")
   //       .required()
   //       .oneOf([Yup.ref("password"), null], "Passwords must match")
   // });

   // const { isLoading } = useSelector((state) => state.auth);

   // const submitRegisterForm = (val) => {
   //    dispatch(
   //       createUser(val, (user) => {
   //          LocalStorageService.setItem("userId", user.id);
   //          setShow(true);
   //       })
   //    );
   // };
   const navigateUrl = () => {
      navigate("/auth/national-org-registration");
   };
   const navigateInternationalDonor = () => {
      navigate("/auth/international-donor-registration");
   };
   const navigateVendor = () => {
      navigate("/auth/vendor-registration");
   };
   return (
      // <div className="d-flex flex-column">
      //    <div className="">
      <div className="container d-flex flex-column align-items-center registration-step1 p-0">
         {/* <div className="header-line"></div> */}
         <div className="frame-logo">
            <RegisterPhoto />
         </div>
         <div className="d-flex justify-content-center align-items-center flex-column mt-5">
            <span className="avatar-bg mt-3">{/* <RegistrationBG /> */}</span>
            <h1 className="my-2 text-org">What Organization type are you?</h1>
         </div>
         <div className="d-flex flex-wrap justify-content-center mt-3 mt-md-3 buttons-registration">
            <button className="nationalOrgBtn mx-3" onClick={navigateUrl} style={{ zIndex: "2" }}>
               National <br /> Organization
            </button>
            <button
               className="internationalDonorBtn mx-3 mx-sm-3"
               style={{ zIndex: "2" }}
               onClick={navigateInternationalDonor}
            >
               International <br />
               Donor
            </button>
            <button
               className="vendorBtn mx-3 mx-sm-3"
               style={{ zIndex: "2" }}
               disabled
               onClick={navigateVendor}
            >
               Vendors
            </button>
         </div>
         <div className="footer">
            <Wave className="wave-svg" />
         </div>
      </div>
      // </div>
      //</div>
      // <>
      //    <Popup show={show} setShow={setShow} />

      //    <BlockUI isLoading={isLoading} />

      //    <div className="login-form login-signin" style={{ display: "block" }}>
      //       <div className="text-center mb-5 mb-lg-10">
      //          <h2>GET STARTED WITH KAPorg</h2>
      //          <p>Create your account in just a few steps</p>
      //       </div>

      //       <Formik
      //          initialValues={initialValues}
      //          validationSchema={RegistrationSchema}
      //          onSubmit={(values) => {
      //             submitRegisterForm(values);
      //          }}
      //       >
      //          {({ handleSubmit, handleChange, values, errors, touched }) => (
      //             <form
      //                onSubmit={handleSubmit}
      //                className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
      //             >
      //                <div className="form-group fv-plugins-icon-container">
      //                   <label>Full name</label>
      //                   <input
      //                      className={`form-control h-auto py-5 px-6`}
      //                      type="text"
      //                      name="fullName"
      //                      onChange={handleChange}
      //                      values={values.fullName}
      //                   />
      //                   {errors.fullName && touched.fullName ? (
      //                      <div className="error-message">{errors.fullName}</div>
      //                   ) : null}{" "}
      //                </div>
      //                <div className="form-group fv-plugins-icon-container">
      //                   <label>Email</label>
      //                   <input
      //                      className={`form-control h-auto py-5 px-6`}
      //                      type="email"
      //                      name="email"
      //                      onChange={handleChange}
      //                      values={values.email}
      //                   />
      //                   {errors.email && touched.email ? (
      //                      <div className="error-message">{errors.email}</div>
      //                   ) : null}{" "}
      //                </div>
      //                <div className="form-group fv-plugins-icon-container">
      //                   <label>Password</label>
      //                   <div className="password-section">
      //                      <input
      //                         className={`form-control h-auto py-5 px-6`}
      //                         type={type}
      //                         name="password"
      //                         onChange={handleChange}
      //                         values={values.password}
      //                      />
      //                      <span className="eyeButton" onClick={handleToggle}>
      //                         <Icon className="icon" icon={icon} size={20} />
      //                      </span>
      //                   </div>
      //                   {errors.password && touched.password ? (
      //                      <div className="error-message">{errors.password}</div>
      //                   ) : null}{" "}
      //                </div>
      //                <div className="form-group fv-plugins-icon-container">
      //                   <label>Confirm password</label>
      //                   <div className="password-section">
      //                      <input
      //                         className={`form-control h-auto py-5 px-6`}
      //                         type={type}
      //                         name="confirmPassword"
      //                         onChange={handleChange}
      //                         values={values.confirmPassword}
      //                      />
      //                      <span className="eyeButton" onClick={handleToggle}>
      //                         <Icon className="icon" icon={icon} size={20} />
      //                      </span>
      //                   </div>
      //                   {errors.confirmPassword && touched.confirmPassword ? (
      //                      <div className="error-message">{errors.confirmPassword}</div>
      //                   ) : null}{" "}
      //                </div>
      //                <div className="d-flex justify-content-between">
      //                   <label className="checkbox">
      //                      <Link
      //                         to="/terms"
      //                         target="_blank"
      //                         className="mr-1 r-btn"
      //                         rel="noopener noreferrer"
      //                      >
      //                         I have read and agreed with the terms and conditions.{" "}
      //                      </Link>
      //                      <input type="checkbox" name="acceptTerms" required className="m-1" />
      //                      <span />
      //                   </label>
      //                </div>

      //                <div className="d-flex justify-content-around">
      //                   <button
      //                      type="submit"
      //                      typkt_login_signin_forme="submit"
      //                      className="btn btn-next font-weight-bold px-25 py-4 my-3 mx-4 "
      //                   >
      //                      Next
      //                   </button>
      //                </div>
      //             </form>
      //          )}
      //       </Formik>

      //       <div></div>
      //    </div>
      // </>
   );
}

export default injectIntl(Registration);
